// extracted by mini-css-extract-plugin
export var details = "_eu-0";
export var inspectorPopover = "_eu-1";